module.exports = __webpack_public_path__ + "social-nav-bar.svg?7511f68e4380212387264d6a8e3d11e8";